module.exports = "../../app/cells/pages/landing_xray/index/print_cell.rb";